'use strict';

module.exports = '<div data-adb-component="appdirectUniversalSearch" class="appdirectUniversalSearch"></div>';



//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/components/templates/appwise-search.tpl.js
// module id = 39
// module chunks = 0